import React, { useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import "../../nikshay/components/nikshay.css";

const wellnessOptions = [
  "Yoga Session",
  "Meditation",
  "Health Awareness Program",
  "Physical Activity",
];

const DailyReport = ({ onClose }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate(-1);
    }
  };

  const [formData, setFormData] = useState({
    entryDate: "",
    male: "",
    female: "",
    otherGender: "",
    totalFootfall: "",
    medicinesDispensed: "",
    diagnosticService: "",
    teleConsultation: "",
    wellnessSession: "",
    participants: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    console.log(formData);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        maxWidth: "1200px",
        mx: "auto",
        mt: 3,
        position: "relative",
      }}
    >
      {/* Header */}
      <div className="patientDetailsTitleHeader-h d-flex mb-0">
        <div className="leftHeaderBar">
          <h4>
            <span>
              <img
                src="/images/National-health-mission.svg"
                alt=""
                style={{ width: "60px", marginRight: "15px" }}
              />
            </span>
            Ayushman Arogya Mandir DAILY REPORT
          </h4>
        </div>
        <div
          className="closeDive nikshayclose"
          onClick={handleClose}
        >
          <img src="/images/closing.svg" alt="Close" />
        </div>
      </div>

      <Grid container spacing={3}>
        {/* Entry Date */}
        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <TextField
            fullWidth
            label="Entry Date"
            type="date"
            name="entryDate"
            value={formData.entryDate}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        {/* OPD Footfall */}
        <Grid size={{ xs: 12 }}>
          <Typography
            variant="subtitle2"
            sx={{ color: "#1976d2", fontWeight: 600 }}
          >
            OPD Footfall (Gender Wise Details)
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <TextField
            fullWidth
            label="Male"
            name="male"
            value={formData.male}
            onChange={handleChange}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <TextField
            fullWidth
            label="Female"
            name="female"
            value={formData.female}
            onChange={handleChange}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <TextField
            fullWidth
            label="Other Gender"
            name="otherGender"
            value={formData.otherGender}
            onChange={handleChange}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <TextField
            fullWidth
            label="Total Footfall"
            name="totalFootfall"
            value={formData.totalFootfall}
            onChange={handleChange}
          />
        </Grid>

        {/* Medicines */}
        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <TextField
            fullWidth
            label="Total Patients dispensed free and essential medicines"
            name="medicinesDispensed"
            value={formData.medicinesDispensed}
            onChange={handleChange}
          />
        </Grid>

        {/* Diagnostic */}
        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <TextField
            fullWidth
            label="Total Patients who availed free and essential diagnostic service"
            name="diagnosticService"
            value={formData.diagnosticService}
            onChange={handleChange}
          />
        </Grid>

        {/* Tele Consultation */}
        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <TextField
            fullWidth
            label="Total Patients received tele-consultation services"
            name="teleConsultation"
            value={formData.teleConsultation}
            onChange={handleChange}
          />
        </Grid>

        {/* Wellness Session */}
        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <TextField
            select
            fullWidth
            label="Wellness Session Organized (Yoga / Other Activities)"
            name="wellnessSession"
            value={formData.wellnessSession}
            onChange={handleChange}
          >
            {wellnessOptions.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Participants */}
        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <TextField
            fullWidth
            label="No of Participants"
            name="participants"
            value={formData.participants}
            onChange={handleChange}
          />
        </Grid>

        {/* Submit */}
        <Grid
          size={{ xs: 12 }}
          sx={{
            textAlign: "right",
          }}
        >
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
              px: 5,
              py: 1,
              backgroundColor: "#3fc4f4",
              borderRadius: "20px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#2db8ea",
              },
            }}
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default DailyReport;
